import { render } from "./CheckRadioPicker.vue?vue&type=template&id=3b54ccfc"
import script from "./CheckRadioPicker.vue?vue&type=script&lang=js"
export * from "./CheckRadioPicker.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__